import { Controller } from "@hotwired/stimulus"
import PhotoSwipeLightbox from 'photoswipe/lightbox'

export default class extends Controller {
  static targets = []

  connect() {
    // Set up image dimensions
    this.element.querySelectorAll('a').forEach((linkEl) => {
      const imageEl = linkEl.querySelector('img')
      if (imageEl) {
        // Wait for image to load to get natural dimensions
        if (imageEl.complete) {
          this.setDimensions(linkEl, imageEl)
        } else {
          imageEl.addEventListener('load', () => {
            this.setDimensions(linkEl, imageEl)
          })
        }
      }
    })

    // Initialize PhotoSwipe
    const lightbox = new PhotoSwipeLightbox({
      gallery: this.element,
      children: 'a',
      pswpModule: () => import('photoswipe')
    })

    lightbox.init()
    this.lightbox = lightbox
  }

  disconnect() {
    if (this.lightbox) {
      this.lightbox.destroy()
    }
  }

  setDimensions(linkEl, imageEl) {
    linkEl.dataset.pswpWidth = imageEl.naturalWidth
    linkEl.dataset.pswpHeight = imageEl.naturalHeight
  }
}
